export default "__VITE_ASSET__Dq4Rg6Iq__"